import {
  createAdminClientContext,
  type AdminHttpClient,
  type AdminHttpOptions,
} from './client.js';
import { buildAllocationsMethods } from './allocations.js';
import { buildAnnouncementsMethods } from './announcements.js';
import { buildLimitsMethods } from './limits.js';
import { buildModelsMethods } from './models.js';
import { buildAuthMethods } from './auth.js';
import { buildDownloadsMethods } from './downloads.js';
import { buildDeviceMethods } from './devices.js';
import { buildPartnersMethods } from './partners.js';
import { buildPlatformMethods } from './platform.js';
import { buildTenantsMethods } from './tenants.js';
import { buildUsageMethods } from './usage.js';
import { buildUsersMethods } from './users.js';
import { buildBillingMethods } from './billing.js';

export type {
  AdminClientContext,
  AdminHttpClient,
  AdminHttpOptions,
  AllocationBatchFields,
  AllocationFields,
  MemberQuotaDefaultFields,
} from './client.js';
export { AdminApiError } from './client.js';
export type { PlatformBillingAdminMethods } from './billing.js';
export { findNewAuditId, latestAuditId } from './audit-helpers.js';
export { withUnauthorizedLogout, withUnauthorizedRetry } from './wrappers.js';

export function createAdminHttp(opts: AdminHttpOptions): AdminHttpClient {
  const ctx = createAdminClientContext(opts);
  return {
    ...buildAuthMethods(ctx),
    ...buildTenantsMethods(ctx),
    ...buildPartnersMethods(ctx),
    ...buildAllocationsMethods(ctx),
    ...buildLimitsMethods(ctx),
    ...buildAnnouncementsMethods(ctx),
    ...buildUsageMethods(ctx),
    ...buildUsersMethods(ctx),
    ...buildModelsMethods(ctx),
    ...buildPlatformMethods(ctx),
    ...buildDownloadsMethods(ctx),
    ...buildDeviceMethods(ctx),
    ...buildBillingMethods(ctx),
  } satisfies AdminHttpClient;
}
